module.exports = __webpack_public_path__ + "img/error.e2200993.png";